import { Trans, useLingui } from '@lingui/react/macro';
import { useCallback, useState } from 'react';
import { toast } from 'react-toastify';

import UDButton from 'ud-ui/components/button';
import Modal from 'ud-ui/components/modal';
import UDText from 'ud-ui/components/text';
import useSaveScheme from 'modules/template-editor/ui/hooks/use-save-scheme';

interface IProps {
  onSuccess: () => void;
}

function useNotionModal(props: IProps) {
  const { t } = useLingui();
  const { onSuccess } = props;
  const [isSaving, setIsSaving] = useState(false);
  const { saveScheme } = useSaveScheme();

  const [isOpen, setIsOpen] = useState(false);
  const open = useCallback(() => {
    setIsOpen(true);
  }, []);
  const close = useCallback(() => {
    setIsOpen(false);
  }, []);

  const save = useCallback(() => {
    setIsSaving(true);
    saveScheme()
      .then(() => {
        toast.success(t`Табло успешно сохранено`);
        onSuccess();
      })
      .catch((error) => {
        console.error(error);
        toast.error(t`Не удалось сохранить`);
      });
  }, [saveScheme, onSuccess, t]);

  return {
    modal: (
      <Modal show={isOpen} onClose={close} size="sm">
        <Modal.Header title={t`Сохранить изменения?`} />
        <Modal.Body>
          <UDText variant="text-2">
            <Trans>У вас есть несохранённые изменения</Trans>
          </UDText>
        </Modal.Body>
        <Modal.Footer>
          <UDButton variant="secondary" type="button" onClick={onSuccess} loading={isSaving}>
            <Trans>Покинуть страницу</Trans>
          </UDButton>
          <UDButton variant="primary" type="button" onClick={save} loading={isSaving}>
            <Trans>Сохранить</Trans>
          </UDButton>
        </Modal.Footer>
      </Modal>
    ),
    open,
    close,
  };
}

export default useNotionModal;
